import { render, staticRenderFns } from "./PcSolveTitle.vue?vue&type=template&id=57408da8&scoped=true&"
import script from "./PcSolveTitle.vue?vue&type=script&lang=js&"
export * from "./PcSolveTitle.vue?vue&type=script&lang=js&"
import style0 from "./PcSolveTitle.vue?vue&type=style&index=0&id=57408da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57408da8",
  null
  
)

export default component.exports